module.exports = __webpack_public_path__ + "static/media/features5.4959e0d6.png";